const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 26,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.33,
    y: 389.21,
    width: 54.1,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.46,
    y: 401.21,
    width: 26.32,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.67,
    y: 399.53,
    width: 19.23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    width: 30.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.23,
    y: 395.31,
    width: 54.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.84,280.93h0c-.49,0-1,0-1.47.06-10.38.83-18.78,10.72-19.44,22.89a28.84,28.84,0,0,0,.68,8,143.17,143.17,0,0,1,3.28,32v31.41c0,2.28,1.58,4.13,3.52,4.13H311.53V280.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.48,305.49c0-14.14-10.19-25.48-22.42-24.5-10.38.83-18.78,10.72-19.44,22.89a28.84,28.84,0,0,0,.67,8,143.18,143.18,0,0,1,3.29,32v31.41c0,2.28,1.57,4.13,3.52,4.13H325c1.94,0,3.52-1.85,3.52-4.13V342a130.72,130.72,0,0,1,3.24-30A28.19,28.19,0,0,0,332.48,305.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.7,
    y: 323.72,
    width: 139.96,
    height: 55.69,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.76,257H244a17.17,17.17,0,0,1,17.17,17.17v59a0,0,0,0,1,0,0H79.59a0,0,0,0,1,0,0v-59A17.17,17.17,0,0,1,96.76,257Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.25,257H248.43a16.93,16.93,0,0,1,16.93,16.93v59.22a0,0,0,0,1,0,0h-173a0,0,0,0,1,0,0V273.92A16.93,16.93,0,0,1,109.25,257Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.42,321.72H282.6a3.68,3.68,0,0,1,3.68,3.68v5.93A3.68,3.68,0,0,1,282.6,335H147.42a1.1,1.1,0,0,1-1.1-1.1V322.82a1.1,1.1,0,0,1,1.1-1.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,379.41H312.58a0,0,0,0,1,0,0v.23a2.76,2.76,0,0,1-2.76,2.76H73.77A2.76,2.76,0,0,1,71,379.64v-.23A0,0,0,0,1,71,379.41Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.06,280.93h0q-.74,0-1.47.06c-10.38.83-18.78,10.72-19.44,22.89a28.84,28.84,0,0,0,.68,8,143.17,143.17,0,0,1,3.28,32v31.41c0,2.28,1.58,4.13,3.52,4.13H143.7V280.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.65,305.49c0-14.14-10.18-25.48-22.42-24.5-10.38.83-18.78,10.72-19.44,22.89a28.84,28.84,0,0,0,.67,8,142.59,142.59,0,0,1,3.29,32v31.41c0,2.28,1.57,4.13,3.52,4.13h26.86c1.94,0,3.52-1.85,3.52-4.13V342a130.72,130.72,0,0,1,3.24-30A28.19,28.19,0,0,0,164.65,305.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.87,
    y: 77.86,
    width: 378.41,
    height: 114.39,
    transform: "translate(502.16 270.1) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.88,
    y: 86.64,
    width: 358.4,
    height: 96.82,
    transform: "translate(502.16 270.1) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.04 183.46 305.62 183.46 278.7 86.64 250.12 86.64 277.04 183.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.21 183.46 339.8 183.46 312.88 86.64 284.29 86.64 311.21 183.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.57 183.46 232.87 183.46 205.95 86.64 191.66 86.64 218.57 183.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.34,
    y: 86.64,
    width: 13.47,
    height: 96.82,
    transform: "translate(502.16 270.1) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.34,
    y: 86.64,
    width: 3,
    height: 96.82,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.72,
    y: 77.86,
    width: 2.16,
    height: 114.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.48,376.83h0a9.22,9.22,0,0,0,9.19-9.19V277.71a9.22,9.22,0,0,0-9.19-9.19h0a9.21,9.21,0,0,0-9.18,9.19v89.93A9.21,9.21,0,0,0,436.48,376.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.22,373.21h0a6.22,6.22,0,0,0,6.21-6.21V278.35a6.22,6.22,0,0,0-6.21-6.21h0a6.22,6.22,0,0,0-6.2,6.21V367A6.22,6.22,0,0,0,431.22,373.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14,376.83h0a9.21,9.21,0,0,0,9.18-9.19V277.71a9.21,9.21,0,0,0-9.18-9.19h0a9.22,9.22,0,0,0-9.19,9.19v89.93A9.22,9.22,0,0,0,423.14,376.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.88,373.21h0a6.23,6.23,0,0,0,6.21-6.21V278.35a6.23,6.23,0,0,0-6.21-6.21h0a6.23,6.23,0,0,0-6.21,6.21V367A6.23,6.23,0,0,0,417.88,373.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.8,376.83h0a9.21,9.21,0,0,0,9.18-9.19V277.71a9.21,9.21,0,0,0-9.18-9.19h0a9.22,9.22,0,0,0-9.19,9.19v89.93A9.22,9.22,0,0,0,409.8,376.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.54,373.21h0a6.22,6.22,0,0,0,6.2-6.21V278.35a6.22,6.22,0,0,0-6.2-6.21h0a6.22,6.22,0,0,0-6.21,6.21V367A6.22,6.22,0,0,0,404.54,373.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.27,
    y: 268.52,
    width: 18.37,
    height: 108.3,
    rx: 9.19,
    transform: "translate(792.91 645.35) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.19,373.21h0A6.22,6.22,0,0,0,397.4,367V278.35a6.22,6.22,0,0,0-6.21-6.21h0a6.22,6.22,0,0,0-6.2,6.21V367A6.22,6.22,0,0,0,391.19,373.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,376.83h0a9.22,9.22,0,0,0,9.19-9.19V277.71a9.22,9.22,0,0,0-9.19-9.19h0a9.22,9.22,0,0,0-9.19,9.19v89.93A9.22,9.22,0,0,0,383.11,376.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.85,373.21h0a6.22,6.22,0,0,0,6.21-6.21V278.35a6.22,6.22,0,0,0-6.21-6.21h0a6.23,6.23,0,0,0-6.21,6.21V367A6.23,6.23,0,0,0,377.85,373.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.77,376.83h0a9.21,9.21,0,0,0,9.18-9.19V277.71a9.21,9.21,0,0,0-9.18-9.19h0a9.22,9.22,0,0,0-9.19,9.19v89.93A9.22,9.22,0,0,0,369.77,376.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,373.21h0a6.23,6.23,0,0,0,6.21-6.21V278.35a6.23,6.23,0,0,0-6.21-6.21h0a6.22,6.22,0,0,0-6.21,6.21V367A6.22,6.22,0,0,0,364.51,373.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.42,376.83h0a9.22,9.22,0,0,0,9.19-9.19V277.71a9.22,9.22,0,0,0-9.19-9.19h0a9.21,9.21,0,0,0-9.18,9.19v89.93A9.21,9.21,0,0,0,356.42,376.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.16,364.79H372.1a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2H345.16a2,2,0,0,0-2,2h0A2,2,0,0,0,345.16,364.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.16,287.29H372.1a2,2,0,0,0,2-2h0a2,2,0,0,0-2-2H345.16a2,2,0,0,0-2,2h0A2,2,0,0,0,345.16,287.29Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-9",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.64,359.66H289.12a10.62,10.62,0,0,1-10.66-11.09l8.41-217.4a11.65,11.65,0,0,1,11.51-11.09H412.9a10.62,10.62,0,0,1,10.66,11.09l-8.41,217.4A11.65,11.65,0,0,1,403.64,359.66Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.69,
    y: 212.97,
    width: 17.98,
    height: 1.1,
    transform: "translate(193.84 628.57) rotate(-87.77)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 193.69,
    width: 7.43,
    height: 1.1,
    transform: "translate(213.78 610.77) rotate(-87.76)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.64,359.66H289.12a10.62,10.62,0,0,1-10.66-11.09l8.41-217.4a11.65,11.65,0,0,1,11.51-11.09H412.9a10.62,10.62,0,0,1,10.66,11.09l-8.41,217.4A11.65,11.65,0,0,1,403.64,359.66Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.68,355.25h-101a9.32,9.32,0,0,1-9.35-9.72l7.87-203.6a10.22,10.22,0,0,1,10.1-9.72h101a9.31,9.31,0,0,1,9.35,9.72l-7.87,203.6A10.23,10.23,0,0,1,392.68,355.25Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.8,
    cy: 339.05,
    rx: 6.78,
    ry: 6.52,
    transform: "translate(-139.35 337.09) rotate(-44.45)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.59,292.75h0a39.28,39.28,0,0,1-39.5-41.1l1.35-35.05h-.07a7.41,7.41,0,0,1-1.18-.1l-1.36,35.15A40.49,40.49,0,0,0,344.54,294a43.93,43.93,0,0,0,31-13,5.46,5.46,0,0,1-.78-1A42.62,42.62,0,0,1,344.59,292.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.43,167.44c-21.43,0-39.8,16-43.38,36.69a6.87,6.87,0,0,1,.8,0c.16,0,.31,0,.47,0,3.54-20,21.33-35.42,42.06-35.42a39.28,39.28,0,0,1,39.51,41.1l-1.62,41.86a42.06,42.06,0,0,1-5.21,18.65,4.62,4.62,0,0,1,1.13.5,43.24,43.24,0,0,0,5.33-19.15l1.62-41.86A40.48,40.48,0,0,0,349.43,167.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.1,176a34.9,34.9,0,0,1,19,5.57,6.37,6.37,0,0,1,.65-1.1,36.1,36.1,0,0,0-19.64-5.72,38.46,38.46,0,0,0-22,7,6.13,6.13,0,0,1,.55,1.12A37.18,37.18,0,0,1,349.1,176Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.4,255.67a35.47,35.47,0,0,1-.34-6.47l1.43-37a37.28,37.28,0,0,1,7.58-21.05,5.18,5.18,0,0,1-1-.66,38.47,38.47,0,0,0-7.8,21.71l-1.43,37a37,37,0,0,0,.36,6.77A6.31,6.31,0,0,1,310.4,255.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.77,188.77a6,6,0,0,1-1,.82,34.78,34.78,0,0,1,7.12,22.65l-1.43,37a38,38,0,0,1-37.61,36.21h0a34.84,34.84,0,0,1-21.33-7.17,5.78,5.78,0,0,1-1.16.7,36,36,0,0,0,22.44,7.72,39.31,39.31,0,0,0,38.91-37.46l1.43-37A36,36,0,0,0,377.77,188.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.81,226.91l.47-12.22a32.87,32.87,0,0,1,32.53-31.32,29.89,29.89,0,0,1,29.66,24.72,7.15,7.15,0,0,1,1.24-.11h0a31.1,31.1,0,0,0-30.88-25.86A34.17,34.17,0,0,0,315,214.69L314.55,227a8.1,8.1,0,0,1,.87-.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.19,275.26a31.8,31.8,0,0,1-13,2.81A29.94,29.94,0,0,1,315,246.75l.29-7.36-.39,0a5.9,5.9,0,0,1-.86-.06l-.29,7.4a31.13,31.13,0,0,0,31.31,32.57,33.18,33.18,0,0,0,13.75-3A5.24,5.24,0,0,1,358.19,275.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.23,220.5c-.18,0-.36,0-.53,0l-1,26.28a32.48,32.48,0,0,1-9.2,21.29,5.7,5.7,0,0,1,.63,1.1,33.75,33.75,0,0,0,9.82-22.39l1-26.29C379.72,220.48,379.48,220.5,379.23,220.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.74,191.85a27,27,0,0,0-11.16-2.39,29.05,29.05,0,0,0-28.76,27.68l-1.05,27.15a28.07,28.07,0,0,0,.24,4.79,6.86,6.86,0,0,1,1.19-.87,25.38,25.38,0,0,1-.18-3.92l1.05-27.15a27.74,27.74,0,0,1,27.46-26.43A25.61,25.61,0,0,1,359.08,193,6.91,6.91,0,0,1,359.74,191.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.36,199.32a6.58,6.58,0,0,1-.83,1,25.37,25.37,0,0,1,5.41,16.82l-1.05,27.15a27.74,27.74,0,0,1-26.29,26.38,6.6,6.6,0,0,1-.53,1.29,29,29,0,0,0,28.07-27.67l1.05-27.15A26.57,26.57,0,0,0,369.36,199.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.29,198.63a7.14,7.14,0,0,1,.18-1.3,23.74,23.74,0,0,0-8.86,3.95,4.68,4.68,0,0,1,1.06.74A22.28,22.28,0,0,1,343.29,198.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.12,247.43a22.63,22.63,0,0,1-21.4,16A20.6,20.6,0,0,1,325,241.84l.86-22.25a21.78,21.78,0,0,1,1.72-7.64,5.08,5.08,0,0,1-.94-1,23.28,23.28,0,0,0-2,8.61l-.86,22.25a21.8,21.8,0,0,0,21.92,22.8,24,24,0,0,0,22.67-16.95A7,7,0,0,1,367.12,247.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,219.59l-.18,4.62a6.51,6.51,0,0,1,1-.1l.27,0,.17-4.55A21.76,21.76,0,0,0,355.37,198a7.53,7.53,0,0,1,0,1.34A20.55,20.55,0,0,1,369,219.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,204.13a18.8,18.8,0,0,0-18.6,17.92l-.19,4.94a7.28,7.28,0,0,1,1.24.19l.2-5.13A17.48,17.48,0,0,1,348,205.39a15.93,15.93,0,0,1,16,16.66l-.67,17.34a17.52,17.52,0,0,1-14.08,16.34,5.89,5.89,0,0,1,0,1.26,18.83,18.83,0,0,0,15.34-17.6l.67-17.34A17.13,17.13,0,0,0,348,204.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.32,218.83a6.57,6.57,0,0,1,.78,0,12.33,12.33,0,0,1,10.58-6.14,11.51,11.51,0,0,1,3.84.66,6.67,6.67,0,0,1,.53-1.15,12.62,12.62,0,0,0-4.32-.77,13.67,13.67,0,0,0-12,7.39A5.88,5.88,0,0,1,336.32,218.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.52,236.94a12.14,12.14,0,0,1-.94,4.16,4.39,4.39,0,0,1,1.09.59,13.36,13.36,0,0,0,1.1-4.75l.48-12.44a13,13,0,0,0-.35-3.45,5.45,5.45,0,0,1-1.19.46,11.33,11.33,0,0,1,.29,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,248.38a11.81,11.81,0,0,1-2.74.33A11.25,11.25,0,0,1,335,236.94l.22-5.63a6.51,6.51,0,0,1-1.24-.23l-.23,5.86a12.45,12.45,0,0,0,12.52,13,13.31,13.31,0,0,0,3.11-.38A7.08,7.08,0,0,1,349,248.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.44,218.81A8.55,8.55,0,0,0,339,227l-.29,7.54a7.61,7.61,0,0,0,.21,2.09,5.31,5.31,0,0,1,1.1-1,6.52,6.52,0,0,1-.06-1.08l.29-7.54a7.23,7.23,0,0,1,7.16-6.88A6.58,6.58,0,0,1,354,227l-.29,7.54a7.24,7.24,0,0,1-4.28,6.26,7.38,7.38,0,0,1-.2,1.4,8.53,8.53,0,0,0,5.73-7.66l.3-7.54A7.78,7.78,0,0,0,347.44,218.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.47,128.9h-35.1a1.94,1.94,0,0,1-1.94-2h0a2.12,2.12,0,0,1,2.1-2h35.09a1.94,1.94,0,0,1,1.95,2h0A2.13,2.13,0,0,1,368.47,128.9Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.57,164a56,56,0,0,1-6.24.14,7.58,7.58,0,0,0-2.24-.14h-.23a83.57,83.57,0,0,1-17.33-3.13c-.58-.17-1.18-.37-1.79-.58l-4.86,125.87,32.48-21.67a11.11,11.11,0,0,0,5-8.78l3.26-84.15A7.28,7.28,0,0,0,313.57,164Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.74,154.61a55.75,55.75,0,0,1-6.23.15,7.93,7.93,0,0,0-2.24-.15l-.24,0a82.94,82.94,0,0,1-17.32-3.13,51.74,51.74,0,0,1-19.13-10.84,7.15,7.15,0,0,0-5-2h-8.48a7.75,7.75,0,0,0-5.14,2,56.7,56.7,0,0,1-20,10.84,86.26,86.26,0,0,1-17.56,3.13l-.24,0a8,8,0,0,0-2.25.15,55.51,55.51,0,0,1-6.22-.15,8,8,0,0,0-8.6,7.58l-3.26,84.16a10.21,10.21,0,0,0,4.29,8.77l47.15,33.16a10.26,10.26,0,0,0,5.93,1.86h8.47a11,11,0,0,0,6.08-1.86l49.71-33.16a11.16,11.16,0,0,0,5-8.77l3.25-84.16A7.31,7.31,0,0,0,305.74,154.61Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.74,154.61a55.75,55.75,0,0,1-6.23.15,7.93,7.93,0,0,0-2.24-.15l-.24,0a82.94,82.94,0,0,1-17.32-3.13,51.74,51.74,0,0,1-19.13-10.84,7.15,7.15,0,0,0-5-2h-8.48a7.75,7.75,0,0,0-5.14,2,56.7,56.7,0,0,1-20,10.84,86.26,86.26,0,0,1-17.56,3.13l-.24,0a8,8,0,0,0-2.25.15,55.51,55.51,0,0,1-6.22-.15,8,8,0,0,0-8.6,7.58l-3.26,84.16a10.21,10.21,0,0,0,4.29,8.77l47.15,33.16a10.26,10.26,0,0,0,5.93,1.86h8.47a11,11,0,0,0,6.08-1.86l49.71-33.16a11.16,11.16,0,0,0,5-8.77l3.25-84.16A7.31,7.31,0,0,0,305.74,154.61Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.34,246.19l3.11-80.47a5.78,5.78,0,0,1,5.72-5.51H200a87,87,0,0,0,23.37-3.5,63.25,63.25,0,0,0,20-10.23,5.54,5.54,0,0,1,7,0,57.57,57.57,0,0,0,19.22,10.24,84.2,84.2,0,0,0,23.11,3.5h1.69a5.35,5.35,0,0,1,5.39,5.61l-3.11,80.37a5.77,5.77,0,0,1-2.57,4.54l-49.4,33a5.52,5.52,0,0,1-6.22,0l-46.86-33A5.28,5.28,0,0,1,189.34,246.19Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.07,241.94l2.64-68.41a105.64,105.64,0,0,0,20.88-3.79,78.16,78.16,0,0,0,19.69-9.06,71.72,71.72,0,0,0,19,9.06,101.52,101.52,0,0,0,20.59,3.79l-2.65,68.41-41.14,27.44Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.9,234.79l1.91-49.41c3.66-.69,7.35-1.56,11-2.61a88.45,88.45,0,0,0,15.83-6.38A82.14,82.14,0,0,0,261,182.77q5.42,1.57,10.83,2.61l-1.91,49.41L242.72,253Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.14,157.64c-1.87,3.88-3.76,7.86-5.58,11.78q-1.36,3-2.62,5.88a57.23,57.23,0,0,0-2.06,5.62,23,23,0,0,0-.56,5.56c0,2.1,0,4.28,0,6.45l.33,13.18-4.62.68a134.84,134.84,0,0,1-2.81-13.21c-.34-2.24-.68-4.49-.86-6.82-.1-1.16-.18-2.34-.2-3.58,0-.63,0-1.26,0-2,0-.34.05-.7.11-1.1s.12-.68.18-1a50,50,0,0,1,2-7c.77-2.18,1.61-4.31,2.48-6.4,1.75-4.19,3.63-8.23,5.73-12.28Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,207.93l-3.84-4.42-4.34.22c-2,4.75,2.35,7.78,2.35,7.78l.77,2.6a1.85,1.85,0,0,0,2.62,1.1L119,214a2,2,0,0,0,1.12-1.82l0-1.49A4.4,4.4,0,0,0,119,207.93Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78,405.47a10.12,10.12,0,0,1-2.07-1.24.21.21,0,0,1-.08-.22.23.23,0,0,1,.18-.17c.37-.07,3.64-.67,4.42.19a.74.74,0,0,1,.14.73,1.27,1.27,0,0,1-.8.94A2.55,2.55,0,0,1,106.78,405.47Zm-1.38-1.29c1.32.91,2.44,1.33,3,1.11a.84.84,0,0,0,.51-.64.28.28,0,0,0,0-.32C108.49,403.87,106.71,404,105.4,404.18Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75,404.26l-.09-.07a.24.24,0,0,1,0-.22c0-.1,1.14-2.56,2.41-3a1.08,1.08,0,0,1,1,.09.74.74,0,0,1,.42.84c-.24,1.05-2.57,2.25-3.57,2.37A.21.21,0,0,1,104.75,404.26Zm3-2.87a.72.72,0,0,0-.52,0c-.76.26-1.55,1.56-2,2.36,1.08-.31,2.64-1.3,2.78-1.93,0-.11,0-.24-.22-.38Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.3,121.62c.83,5.48,2.7,17.43-1.29,21,0,0,1.24,5.57,11.39,5.77,11.17.22,5.59-5.44,5.59-5.44-6-1.57-5.67-6.08-4.41-10.3Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.16,112.54l-.18-.09a.44.44,0,0,1,0-.61,4.44,4.44,0,0,1,3.65-1.69.43.43,0,0,1,.38.48.45.45,0,0,1-.49.39h0a3.56,3.56,0,0,0-2.87,1.37A.47.47,0,0,1,164.16,112.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.24,117.93a19.3,19.3,0,0,0,2,5,3.17,3.17,0,0,1-2.68.24Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.73,116.59c-.09.74.23,1.38.71,1.43s.94-.52,1-1.26-.23-1.38-.71-1.43S165.82,115.85,165.73,116.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.55,115.35l1.83-.34S167.3,116.31,166.55,115.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.64 409.13 184.38 406.05 183.43 386.21 173.68 389.28 174.64 409.13",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.69 402.04 103.46 404.52 110.81 384.21 102.03 381.73 94.69 402.04",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.58,402.77l-9.4-4a.74.74,0,0,0-.92.3l-4.41,7.15a1.46,1.46,0,0,0,.67,2.09c3.31,1.32,5,1.79,9.1,3.54,2.54,1.07,4.53,4.33,10.12,4.33,3.78,0,4.5-3.42,3-3.92-7-2.24-5.57-5.57-7-8.4A2.3,2.3,0,0,0,104.58,402.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.86,407.42a11.62,11.62,0,0,1-2.45-.33.24.24,0,0,1-.17-.18.22.22,0,0,1,.09-.22c.31-.2,3-2,4.13-1.52a.78.78,0,0,1,.46.61,1.22,1.22,0,0,1-.33,1.16A2.55,2.55,0,0,1,187.86,407.42Zm-1.84-.64c1.61.32,2.82.26,3.27-.16a.81.81,0,0,0,.2-.78.35.35,0,0,0-.19-.28C188.72,405.3,187.14,406.09,186,406.78Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,407.09l-.11,0a.2.2,0,0,1-.11-.18c0-.12-.08-2.77.89-3.65a1.08,1.08,0,0,1,.92-.29.8.8,0,0,1,.75.6c.24,1-1.37,3-2.23,3.53A.2.2,0,0,1,185.46,407.09Zm1.45-3.73a.73.73,0,0,0-.48.19c-.58.53-.73,2-.76,2.9.86-.7,1.85-2.19,1.7-2.82,0-.1-.08-.23-.36-.26Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.65,405.81H174.31a.7.7,0,0,0-.72.63l-.91,8.18a1.54,1.54,0,0,0,1.53,1.64c3.61-.06,5.34-.27,9.89-.27,2.8,0,6.89.29,10.76.29s3.94-3.82,2.32-4.17c-7.26-1.55-8.47-3.69-11-5.73A2.48,2.48,0,0,0,184.65,405.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.42 386.21 183.94 396.84 174.17 399.52 173.68 389.29 183.42 386.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.03 381.74 110.8 384.22 107.02 394.68 98.24 392.2 102.03 381.74",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,143.78c-3.84.9-8.06,14.73-8.06,14.73l10.71,11.33s9.1-13.07,7.31-17.79C130.07,147.13,126.49,142.72,122,143.78Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,143.78c-3.84.9-8.06,14.73-8.06,14.73l10.71,11.33s9.1-13.07,7.31-17.79C130.07,147.13,126.49,142.72,122,143.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.93,152.45c2-1.8,3.26-1.3,4.14.1.84,4.07-4.85,13.29-7,16.57C124.16,165.27,123.52,156.54,127.93,152.45Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,147c.53,4,.2,16.29-7.56,53.47l-37.39-.73c1.31-15.19,1.75-24.57-4.11-55.92a112.33,112.33,0,0,1,16-1.77,119.38,119.38,0,0,1,17,.33c5.41.6,11.34,1.78,14,2.35A2.65,2.65,0,0,1,171,147Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,147c.53,4,.2,16.29-7.56,53.47l-37.39-.73c1.31-15.19,1.75-24.57-4.11-55.92a112.33,112.33,0,0,1,16-1.77,119.38,119.38,0,0,1,17,.33c5.41.6,11.34,1.78,14,2.35A2.65,2.65,0,0,1,171,147Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.29,111.7c-.54,9.15-1,13,3.05,18.12,6,7.68,17.32,6,20.57-2.83,2.92-8,3.31-21.62-5.11-26.08S141.82,102.55,141.29,111.7Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59,200.24S148.16,267,141,302.43c-5.78,28.65-32,90.56-32,90.56l-11.41-4.82S110.8,318.05,119.73,301c10-58.81-6.19-78.86,6.34-101.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42,236.75c-4.09,17.39-1.44,33.18,1.33,43.6,1.64-11.17,3.12-23.2,4.38-34.47C147.4,242.64,145.23,239.58,143.42,236.75Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.46,200.43s14.2,65.19,16,93.06c1.9,29,5.71,97.7,5.71,97.7l-12.52,3.36s-14.08-70.81-13-92.12c-7-30.24-31.41-102.65-31.41-102.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.06 394.37 170.8 397.11 169.24 391.31 186.65 388.35 187.06 394.37",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.05 393.56 95.82 389.25 96.67 383.6 112.95 387.61 111.05 393.56",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.61,197.5l-1.84,3.31c-.14.25.16.52.59.53l39.21.77c.34,0,.63-.15.66-.36l.49-3.34c0-.23-.25-.43-.62-.44l-37.87-.74A.67.67,0,0,0,125.61,197.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5,201.83l-1,0c-.2,0-.35-.12-.33-.24l.67-4.34c0-.12.2-.22.4-.22l1,0c.2,0,.35.11.33.24l-.67,4.33C130.89,201.73,130.71,201.83,130.5,201.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09,202.31l-1,0c-.2,0-.35-.11-.33-.24l.67-4.33c0-.13.2-.23.41-.23l1,0c.2,0,.35.11.33.24l-.67,4.33C155.47,202.21,155.29,202.31,155.09,202.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.07,151.71c1.83,3.89,3.87,7.93,6,11.76a86.22,86.22,0,0,0,6.89,10.89c.32.41.64.83.9,1.13s.59.66.93,1a23.52,23.52,0,0,0,2.22,1.91,47,47,0,0,0,5.27,3.45,114.12,114.12,0,0,0,11.85,5.81l-1.22,4.5a66.55,66.55,0,0,1-13.75-3.87A45.54,45.54,0,0,1,185.5,185a29.67,29.67,0,0,1-3.21-2.25c-.53-.42-1-.89-1.55-1.38s-1-1-1.36-1.44c-.86-.93-1.62-1.88-2.4-2.83s-1.48-1.94-2.16-2.93c-1.4-2-2.66-4-3.88-6a110.33,110.33,0,0,1-6.49-12.62Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.38,144.55c8.76,1.91,10.88,15.68,10.88,15.68l-8.63,10.06s-13.71-13-13-20.07C158.1,145,163.6,143.51,168.38,144.55Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.38,144.55c8.76,1.91,10.88,15.68,10.88,15.68l-8.63,10.06s-13.71-13-13-20.07C158.1,145,163.6,143.51,168.38,144.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.26,191.2l-2.43-2.87s-7.84-1.83-11.31-.13l-1.07,3.23,8.76,4.54,1.83.86a2,2,0,0,0,2.52-.71l1.76-2.48A2,2,0,0,0,217.26,191.2Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.86,162.25c1.53-4.08,2.38-9,2-11.35-.52,4.18-3.7,9.9-6.89,14.15a40.89,40.89,0,0,1-35.55-2.52c-2.63-5.32-4.81-13.63-3.43-18.59-1.69,2.52-2.94,9.41-2.14,14.27-2.69-2.75-4.26-5.84-4.27-8.88,0-14.61,17.61-13.72,17.85-24.38s-4.1-32.45,17.64-27.8c14.24-.67,11.26,11.89,8.94,19.53C158.9,123.73,180.44,150.79,166.86,162.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.11,97.15c8.9-4.75,18,2.73,13.34,10.56-4.11-.18-7.44,2.43-4.22,7.65C151.68,109.34,145.83,97.68,152.11,97.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.47,114a9,9,0,0,1,1.16,5.52c-.28,2.46-2.2,2.46-3.55,1s-2.47-4.49-1.69-6.37A2.22,2.22,0,0,1,161.47,114Z",
    style: {
      fill: "#ff8b7b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityRafiki);
export default __webpack_public_path__ + "static/media/Security-rafiki.29a606e7934f872de9ce7d57849e8f12.svg";
export { ForwardRef as ReactComponent };